import { Component, Input } from '@angular/core';
import { ImportViewModel } from '@app/core/interfaces/portal/import-item';
import { Upload } from '@app/shared/services/upload.service';
import { PortalError } from '@app/utils/error/portal-error';
import { Observable } from 'rxjs';
import { ContactImportItem } from './contacts-import-models';

@Component({
  selector: 'portal-contacts-export-import',
  templateUrl: './contacts-export-import.component.html',
  styles: [],
  standalone: false,
})
export class ContactsExportImportComponent {
  @Input()
  title!: string;

  @Input()
  downloadUrl!: string;

  @Input()
  noCard: boolean = false;

  @Input()
  templateDownloadUrl!: string;

  @Input()
  upload!: (file: File, replaceOld: boolean) => Observable<Upload<ImportViewModel<ContactImportItem>>>;

  collapseErrors: boolean = true;
  collapseWarnings: boolean = true;
  error: PortalError | null = null;
  fileUploadProgress!: number;
  importFile: File;
  importedDataDefined: boolean = false;
  importedData: ImportViewModel<ContactImportItem>;
  replaceOldContacts: boolean = false;
  uploadInProgress: boolean = false;

  importFileChanged(file: File) {
    this.importFile = file;
    this.importedDataDefined = false;
  }

  importPhoneBookClicked() {
    this.error = null;

    this.upload(this.importFile, this.replaceOldContacts).subscribe({
      error: (error) => {
        this.error = error;
      },
      next: (upload) => {
        this.fileUploadProgress = upload.progress;
        this.uploadInProgress = upload.finished === false;

        if (upload.finished) {
          this.importedData = upload.response;
          this.importedDataDefined = true;
        }
      },
    });
  }
}
